import axios from 'axios';
import { toast } from 'react-toastify';
// export const BASE_URL = "https://app.vm.dev.turingtower.com"; 
export const BASE_URL = "http://localhost:3000/"; 

// Create an Axios instance



// const baseurl = process.env.NODE_ENV === 'production' 
//     ? 'https://core.vm.dev.turingtower.com/api/' // Replace with your production API base URL
//     : 'https://core.vm.dev.turingtower.com/api/';

// http://localhost:8000/api/

    // https://local.core.vm.dev.turingtower.com:8000/api/'
const api = axios.create({
    // baseURL: baseurl, // Replace with your API base URL
    baseURL: 'https://core.vm.dev.turingtower.com/api/', // Replace with your API base URL
    // baseURL: 'http://localhost:8000/api/', // Replace with your API base URL
    timeout: 60000,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});

// Request interceptor to add authorization header if access token exists
api.interceptors.request.use(
    config => {
      const accessToken = sessionStorage.getItem('authToken');
      if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
      }

      
      return config;
    },
    (error) => {
    // if (error.response?.status === 401) {
    //   sessionStorage.clear(); // Optional: clear session
    //   window.location.href = "/"; // Redirect
    // }
    return Promise.reject(error);
  }
);

let redirected = false
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    
    if (status === 401 && !redirected) {   
      redirected = true // Prevent repeat redirects
      sessionStorage.clear(); // clear all session data
      toast.error("User session expired");  
       window.location.href = "/"; // Redirect
    }

    return Promise.reject(error);
  }
);

export const getInventory = async(page) => {
  try {
    let response = await api.get(`/inventory?page=${page}`);
    return response.data;
  } catch (error) {
    return {
      status: false,
      message: error.response.data.message || "An error occurred"
    };
  }
};

export const getAssetGroups = async(page) => {
  try {
    let response = await api.get(`/inventory/get-asset-groups?page=${page}`);
    return response.data;
  } catch (error) {
    return {
      status: false,
      message: error.response.data.message || "An error occurred"
    };
  }
};

export const getUnknownAssets = async(page) => {
  try {
    let response = await api.get(`/inventory/get-unknown-assets?page=${page}`);
    return response.data;
  } catch (error) {
    return {
      status: false,
      message: error.response.data.message || "An error occurred"
    };
  }
};

export const deleteInventory = async (ids) => {
    try {
        const response = await api.delete(`/inventory/delete`, { data: { ids } });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const register = async(formData) =>{
    
    try {

        let response = await api.post('/register',formData);

        return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message
        }
        // console.log(error.response.data);
        
        
    }
    
}

export const login  = async(formData) =>{

    try {

        let response = await api.post('/login',formData);

        return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message
        }
        // console.log(error.response.data);
        
        
    }

    
}
export const getUserData = async() =>{

    try {

        let response = await api.get('/user');

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getUserStatistics = async(formData) =>{

    try {

        let response = await api.get('/statistics');

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const createTarget = async(formData) =>{
    try {

        let response = await api.post('/target/create',formData);

        
        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: response.message
            }
        }

        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: "Sorry. "+error.response.data.error
        }
        // console.log(error.response.data);
        
        
    }
}

export const getTargets = async(page, isScanned) =>{

    try {

        let response = await api.get(`/target/all?page=${page}&isScanned=${isScanned}`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getTargetList = async(id, page) =>{

    try {

        let response = await api.get(`/target/single/${id}?page=${page}`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getAllTargets = async() =>{

    try {

        let response = await api.get(`/target/all-targets`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getCredentials = async(page) =>{

    try {

        let response = await api.get(`/credential/all?page=${page}`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getAllCredentials = async() =>{

    try {

        let response = await api.get(`/credential/all-credentials`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getRoles = async() =>{

    try {

        let response = await api.get('/get-roles');

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getTeam = async(page) =>{

    try {

        let response = await api.get(`/team?page=${page}`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const addTeamMember = async (data) => {
  try {
    const response = await api.post("/team/member/create", data);
    return response.data; // Only return the relevant data
  } catch (error) {
    // Let the error bubble up to React Query's onError
    throw error;
  }
};


export const editTeamMember = async (id, permission_level) => {
  try {
    const res = await api.post(`/team/member/${id}/permission`, permission_level);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const deleteTeamMember = async (id) => {
  try {
    const res = await api.delete(`/team/member/${id}/delete`);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const resendInvite = async (email) => {
  try {
    const res = await api.post(`/team/member/resend`, email);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const cancelInvite = async (id) => {
  try {
    const res = await api.delete(`/team/member/${id}/cancel`);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const getInsights = async() =>{

    try {

        let response = await api.get('/insights');

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getCVEResults = async(cve) =>{

    try {

        let response = await api.get(`/cve-search/${cve}`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getCVEResultsWithStrings = async (data) => {
    try {
        const response = await api.post(`/cve-search-by-string`,  data );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getInsightsGraph = async() =>{

    try {

        let response = await api.get('/insights-vulnerability-severity-graph');

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getInsightsSeverityGraph = async(startDate, endDate) =>{

    try {

        let response = await api.get(`/insights-severity-graph/${startDate}/${endDate}`);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}



export const exportAsPdf = async (id) => {
    try {
      let response = await api.get(`/export-report-as-pdf/${id}`, {
        responseType: "blob", // Ensure response is treated as binary data
        timeout: 20000,
        headers: {
          Accept: "application/pdf",
        },
      });
  
      if (response.status === 200) {
        return response.data; // Directly return the Blob
      } else {
        throw new Error("Failed to fetch PDF");
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
      return {
        status: false,
        message: error.response?.data?.message || "An error occurred",
      };
    }
  };
  

export const exportAsCsv = async(id) =>{

    try {

        let response = await api.get(`/export-report-as-csv/${id}`, {
            responseType: "blob", // Ensure response is treated as binary data
            timeout: 20000,
            headers: {
              Accept: "text/csv; charset=UTF-8",
            },
          });

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occurred'
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}



export const createScan = async(formData) =>{
    try {

        let response = await api.post('/scan/create',formData);

        
        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: response.message
            }
        }

        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: "Sorry. "+ error.response.data.error
        }
        // console.log(error.response.data);
        
        
    }
}

//start a pending scan whose autoStartScan is false
export const startScan = async(id) =>{

    try {

        let response = await api.get('/scan/start-scan/'+id);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: response.data.message || "An error occurred. Please try again later."
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

//fetch the scans task status and report id
export const getScanTaskStatus = async(task_id) =>{

    try {

        let response = await api.get('/get-scan-status/'+task_id);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: response.data.message || "An error occurred. Please try again later."
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}


//fetch the scans report and breakdown
export const getScanReport = async(id) =>{

    try {

        let response = await api.get('/scan/get-report/'+id);

        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: response.data.message || "An error occurred. Please try again later."
            }
        }
        // return response;
        
    } catch (error) {

        return {
            status: false,
            message: error.response.data.message || "An error occurred"
        }
        // console.log(error.response.data);
        
        
    }

    
}

export const getScans = async ({
  page = 1,
  status,
  schedule,
} = {}) => {
  try {
    const params = new URLSearchParams();

    // Always include page
    params.append("page", page);

    // Append optional filters if provided
    if (status) params.append("status", status);
    if (schedule !== undefined) params.append("isScheduled", schedule);

    const response = await api.get(`/scan/all?${params.toString()}`);

    if (response) {
      return response.data;
    } else {
      return {
        status: false,
        message: "An error occurred",
      };
    }
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || "An error occurred",
    };
  }
};


// Function to get data from an endpoint
export const getData = async (endpoint) => {
    try {
        const response = await api.get(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

// Function to post data to an endpoint
export const postData = async (endpoint, data) => {
    try {
        const response = await api.post(endpoint, data);
        return response.data;
    } catch (error) {
        console.error('Error posting data:', error);
        throw error;
    }
};

// Function to update data at an endpoint
export const updateData = async (endpoint, data) => {
    try {
        const response = await api.put(endpoint, data);
        return response.data;
    } catch (error) {
        console.error('Error updating data:', error);
        throw error;
    }
};

// Function to delete data from an endpoint
export const deleteData = async (endpoint) => {
    try {
        const response = await api.delete(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error deleting data:', error);
        throw error;
    }
};
export const getRiskScore = async () => {
    try {
        const response = await api.get('/risk-score');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteTarget = async (id) => {
    try {
        const response = await api.delete(`/target/delete/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const startScanWithId = async (id) => {
    try {
        const response = await api.post(`/scan/start-scan`, { id });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};
export const repeatScanWithId = async (id) => {
    try {
        const response = await api.post(`/scan/re-run-scan`, { id });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const stopScanWithId = async (id) => {
    try {
        const response = await api.post(`/scan/stop-scan`, { id });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteScanWithId = async (id) => {
    try {
        const response = await api.post(`/scan/delete-scan`, { id });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateScheduleScanWithId = async (id, data) => {
    try {
        const response = await api.post(`/scan/update-scheduled/${id}`, data );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getUserVulnerabilities = async (page, severity, status) => {
    try {
        const response = await api.get(`/user-vulnerabilities/?per_page=10&page=${page}&severity=${severity}&status=${status}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const exportUserVulnerabilities = async (severity) => {
  try {
    const response = await api.get(`/export-vulnerability/?severity=${severity}`, {
      responseType: 'blob', // important for file download
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const searchUserVulnerabilities = async (data) => {
  try {
    const res = await api.post("/search-user-vulnerabilities", data);
    return res.data;
  } catch (error) {
    throw error?.response?.data || { message: error.message };
  }
};

export const exportSetup = async () => {
  try {
    const response = await api.get(`/export-setup-zip`, {
      responseType: 'blob', // important for file download
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportSampleFile = async () => {
  try {
    const response = await api.get(`/inventory/sample-csv`, {
      responseType: 'blob', // important for file download
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const acceptVulnerability = async (id) => {
    try {
        const response = await api.post(`/vulnerability/accept`, { id });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const resolveVulnerability = async (id) => {
    try {
        const response = await api.post(`/vulnerability/resolve`, { id });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createAssetGroup = async (data) => {
    try {
        const response = await api.post(`/inventory/create-asset-group`, data);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateAssetGroup = async (data) => {
    try {
        const response = await api.post(`/inventory/update-asset-group`, data);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export default api;
